import { Col, Container, Row } from "react-bootstrap";
import './numSection.css';

function NumSection(){
    return(
        <>
        <section id="section-one">
        <Container>
            <Row style={{textAlign:'center'}}>
                <Col>
                    <h4>1282+</h4>
                    <span>Savings</span>
                </Col>
                <Col>
                    <h4>5786+</h4>
                    <span>PHOTOS</span>
                </Col>
                <Col>
                    <h4>1440+</h4>
                    <span>ROCKETS</span>
                </Col>
                <Col>
                    <h4>7110+</h4>
                    <span>GLOBES</span>
                </Col>
            </Row>
        </Container>
        </section>
        </>
    )
}

export default NumSection;